import cx from 'classnames';
import assetUrl from 'mk/common/assetUrl';
import { BlogPostEntity, PostVisibility } from 'mk2/apps/blogs/schemas';
import Img from 'mk2/components/Img';
import React from 'react';
import styles from './BlogPostVisibilityMenuTrigger.mscss';

interface OwnProps {
    className?: string;
    enabled: boolean;
    post: BlogPostEntity;

    onClick: React.MouseEventHandler<HTMLElement>;
}

type Props = OwnProps;

class BlogPostVisibilityMenuTrigger extends React.Component<Props> {

    public render() {
        const { className, enabled, onClick, post } = this.props;

        const iconName = {
            [PostVisibility.Public]: 'icon-visibility-0.gif',
            [PostVisibility.Authenticated]: 'icon-visibility-1.gif',
            [PostVisibility.Friends]: 'icon-visibility-2.gif',
            [PostVisibility.Private]: 'icon-visibility-3.gif',
        }[post.visibility];

        const icon = (
            <Img
                className={styles.BlogPostVisibilityMenuTrigger__icon}
                src={assetUrl + 'img/photoblog/' + iconName}
                width={11}
                height={11}
            />
        );

        return enabled ? (
            <div
                className={cx(styles.BlogPostVisibilityMenuTrigger, styles['BlogPostVisibilityMenuTrigger--enabled'], className)}
                onClick={onClick}
                role="button"
                tabIndex={0}
            >
                {icon}
                ▾
            </div>
        ) : (
            <div
                className={cx(styles.BlogPostVisibilityMenuTrigger, className)}
                role="button"
            >
                {icon}
            </div>
        );
    }

}

export default BlogPostVisibilityMenuTrigger;
